import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";
import { useContact } from "@/context/ContactContext";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { openContact } = useContact();
  return (
    <footer
      data-testid={FOOTER.root}
      className="border-t border-border/60 bg-background/80"
    >
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <img src="/logo-mark.jpg" alt="Printopia" className="h-10 w-10 rounded-lg object-cover ring-1 ring-[rgba(0,229,255,0.35)]" />
              <span className="font-display text-lg font-semibold tracking-tight">
                Print<span className="text-neo-cyan">opia</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">
              The all-new 3D printing marketplace. Discover prints from
              independent makers, or turn your own printer into a side gig.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-2">
            <div>
              <h4 className="font-display text-sm font-semibold text-foreground">Marketplace</h4>
              <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
                <li><a href="#marketplace" className="transition-colors hover:text-foreground">Browse designs</a></li>
                <li><a href="#how-it-works" className="transition-colors hover:text-foreground">How it works</a></li>
                <li><a href="#custom" className="transition-colors hover:text-foreground">Sell your designs</a></li>
                <li><a href="#download" className="transition-colors hover:text-foreground">Get the app</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-display text-sm font-semibold text-foreground">Legal</h4>
              <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
                <li>
                  <Link
                    data-testid={FOOTER.privacy}
                    to="/privacy"
                    className="transition-colors hover:text-foreground"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li><Link to="/privacy" className="transition-colors hover:text-foreground">Terms of Service</Link></li>
                <li>
                  <button
                    data-testid={FOOTER.contact}
                    onClick={openContact}
                    className="transition-colors hover:text-foreground"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-border/60 pt-6 sm:flex-row sm:items-center">
          <p className="font-mono text-xs text-muted-foreground">
            © {year} Printopia, Inc. All rights reserved.
          </p>
          <p className="font-mono text-[11px] text-muted-foreground">
            Print it &bull; Sell it &bull; Ship it
          </p>
        </div>
      </div>
    </footer>
  );
};
